import React, { useEffect, useState } from "react";
import * as Template from "../../templates";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import * as actions from "../../actions";
import { formatNumber } from "../../libraries/helper";
import { InputDatePicker } from "jalaali-react-date-picker";
import moment from "moment-jalaali";

const CreateProductPrice = () => {

  const moduleName = `product_prices`;

  const params = useParams()

  const [id, setId] = useState();

  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();
  const [product, setProduct] = useState()
  const [warranties, setWarranties] = useState([])
  const [activeWarranty, setActiveWarranty] = useState()
  const [discount, setDiscount] = useState()
  const [via, setVia] = useState()
  const [visible, setVisible] = useState(false)
  const [priceName, setPriceName] = useState(``)
  const [code, setCode] = useState(``)
  const [barcode, setBarcode] = useState(``)
  const [maxDeliveryDay, setMaxDeliveryDay] = useState(``)
  const [maxCartCount, setMaxCartCount] = useState(``)
  const [priceValue, setPriceValue] = useState(``)
  const [availableCount, setAvailableCount] = useState(``)
  const [updateId, setUpdateId] = useState(0)
  const [channel, setChannel] = useState()
  const [activeAttribute, setActiveAttirbute] = useState()
  const [activeState, setActiveState] = useState()
  const [productPrices, setProductPrices] = useState([])
  const [stateSubmit, setStateSubmit] = useState(false)
  const [updateSubmit, setUpdateSubmit] = useState(false)
  const [expireAt, setExpireAt] = useState();
  const [startAt, setStartAt] = useState();

  const handleReset = () => {
    if(!updateId){
      setPriceName(``)
      setCode(``)
      setBarcode(``)
      setMaxCartCount(``)
      setMaxDeliveryDay(``)
      setAvailableCount(``)
      setPriceValue(``)
      setDiscount(0)
      setVia(``)
      setChannel(``)
      setActiveWarranty(``)
      setActiveState(``)
    }
   
  }

  const handleAttribute = (item) => {
    setVisible(true)
    handleReset()
    setActiveAttirbute(item.id)
  }

  const handleClickUpdate = () => {
    setUpdateSubmit(true)
    dispatch(actions.update(updateId, moduleName))
    setUpdateId(undefined)
    setActiveAttirbute(undefined)
  }

  const handlePublish = (id) => {
    setStateSubmit(true)
    dispatch(actions.publish(id, moduleName))
  }

  const handleUnPublish = (id) => {
    setStateSubmit(true)
    dispatch(actions.unpublish(id, moduleName))
  }

  const handleClick = () => {
    dispatch(actions.store(moduleName))
  }

  const handleDelete = (currentId) => {
    dispatch(actions.destroy(currentId, moduleName))
  }

  const handleUpdate = (currentId) => {
    setVisible(true)
    setUpdateId(currentId)
    dispatch(actions.edit(currentId, moduleName))
  }

  useEffect(() => {

    if (appReducer.warranties_option_list != undefined) {
      setWarranties(appReducer.warranties_option_list.data)
    }

    if (updateSubmit) {
      if (appReducer.product_prices_update != undefined) {
        handleReset()
        setVisible(false)
        setUpdateSubmit(false)
        dispatch(actions.list(moduleName, "?product=" + id))
      }
    }

    if (appReducer.products_edit != undefined) {
      setProduct(appReducer.products_edit.data)
    }


    if (appReducer.product_prices_edit != undefined) {
      let edit = appReducer.product_prices_edit.data
      setPriceName(edit.name)
      setCode(edit.code)
      setBarcode(edit.barcode)
      setMaxCartCount(edit.max_cart_count)
      setMaxDeliveryDay(edit.max_delivery_day)
      setAvailableCount(edit.available_count)
      setPriceValue(edit.price)
      setDiscount(edit.discount)

      if(edit.attribute_item){
        setActiveAttirbute(edit.attribute_item.id)
      }
      
      if(edit.expire_at){
        setExpireAt(moment(edit.expire_at_timestamp));
      }

      if(edit.start_at){
        setStartAt(moment(edit.start_at_timestamp));
      }

      setVia({
        value: edit.via,
        label: edit.via,
      })
      setChannel({
        value: "وب‌سایت",
        label: "وب‌سایت"
      })
      setActiveWarranty({
        value: edit.warranty.id,
        label: edit.warranty.slug
      })
      setActiveState({
        value: edit.state,
        label: edit.state == `active` ? `فعال` : `غیرفعال`
      })
    }

    if (appReducer.product_prices_list != undefined) {
      setProductPrices(appReducer.product_prices_list.data)
    }

    if (stateSubmit) {

      if (appReducer.product_prices_store != undefined ||
        appReducer.product_prices_update != undefined ||
        appReducer.product_prices_destroy != undefined ||
        appReducer.product_prices_publish != undefined ||
        appReducer.product_prices_unpublish != undefined
      ) {
        setStateSubmit(false)
        dispatch(actions.list(moduleName, "?product=" + id))
      }

    }


  }, [appReducer])

  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.list(moduleName, `?product=${id}`));
      dispatch(actions.edit(id, "products"))
      dispatch(actions.list("warranties/option"))
    }
  }, [id]);


  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])


  const columns = [
    {
      name: 'عنوان تنوع',
      selector: row => <div className="">
        <span className="px-3"> {row.name}</span>
      </div>,
    },
    {
      name: 'تنوع',
      selector: row => <div className="">
        <span className="px-3"> {row.attribute_item ? row.attribute_item.name : "-"}</span>
      </div>,
    },
    {
      name: 'تصویر',
      selector: row => row.url_small_full != "" ? <img src={row.url_small_full} /> : "-"
    },
    {
      name: 'بارکد',
      selector: row => row.barcode ?? "-"
    },
    {
      name: 'تاریخ تولید',
      selector: row => row.start_at != null  ?  row.start_at_fa : "-"
    },
    {
      name: 'تاریخ انقضا',
      selector: row => row.expire_at != null  ?  row.expire_at_fa : "-"

    },
    {
      name: 'کد تنوع (PC)',
      selector: row => row.code
    },
    {
      name: 'گارانتی',
      selector: row => row.warranty.name
    },
    {
      name: 'ارسال توسط',
      selector: row => row.via
    },
    {
      name: 'کانال فروش',
      selector: row => row.channel
    },
    {
      name: 'قیمت فروش (تومان)',
      selector: row => formatNumber(row.price)
    },
    {
      name: 'تخفیف (درصدی)',
      selector: row => row.discount > 0 ? row.discount : "ندارد"
    },
    {
      name: 'بازه زمانی ارسال (روز)',
      selector: row => row.max_delivery_day
    },
    {
      name: 'موجودی',
      selector: row => row.available_count
    },
    {
      name: 'تعداد در سبد',
      selector: row => row.max_cart_count
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    },
    {
      name: 'عملیات',
      width: "350px",
      selector: row => <div className="py-3 flex gap-2 items-start">
        <Template.Button
          label="حذف"
          background="bg-gradient-to-tr from-red-300 to-red-400  text-xs"
          onClick={() => handleDelete(row.id)}
        />
        <Template.Button
          label="ویرایش"
          background="bg-gradient-to-tr from-indigo-300 to-indigo-400  text-xs"
          onClick={() => handleUpdate(row.id)}
        />

        {row.state != "active" ? (
          <Template.Button
            onClick={() => handlePublish(row.id)}
            label="انتشار"
            background="bg-gradient-to-tr from-teal-300 to-teal-400  text-xs"
          />
        ) : (
          <Template.Button
            onClick={() => handleUnPublish(row.id)}
            label="عدم‌انتشار"
            background="bg-gradient-to-tr from-blue-300 to-blue-400  text-xs"
          />
        )}
      </div>,
    }
  ];



  return (
    <div className=" bg-white p-5 shadow">
      {product && <div className="flex items-start gap-4">
        <div className="border p-5 rounded-md">
          <img className="w-24" src={product.images[0].url_full} />
        </div>
        <div className="flex flex-col py-4 space-y-4">
          <h3 className="font-bold">{product.name}</h3>
          <ul className="flex flex-col space-y-1 text-neutral-500">
            <li className="flex gap-3"><b>گروه:</b> <span>{product.category.name}</span></li>
            <li className="flex gap-3"><b>تنوع قیمت بر اساس‌:</b><span>{product.attribute ?  product.attribute.name : "-"}</span></li>
          </ul>
        </div>
      </div>}

      {product && !product.attribute && <div className="my-4">
        <Template.Button
          onClick={() => {
            handleReset()
            setVisible(true)
          }}
          label="افزودن تنوع جدید"
        />
      </div>}


      {product && product.attribute &&   <ul className="flex flex-wrap items-center   gap-5 my-5">
        {product.attribute.attribute_items.map((item, c) => {
          return (
            <li className={`bg-gray-100 cursor-pointer hover:bg-gray-300 p-3  rounded-md ${activeAttribute && item.id == activeAttribute ? "bg-gray-800 text-white" : ""}`} key={c} onClick={() => handleAttribute(item)}>
               <span className="px-3"> {item.name}</span>
            </li>
          );
        })}
      </ul>}

      {visible && <Template.Form>

        {activeAttribute && <input type="hidden" name="attribute_item_id" defaultValue={activeAttribute} /> }

        <input type="hidden" defaultValue={id} name="product_id" />

        <Template.Input required label="نام تنوع" value={priceName} name="name" type="text" />

        <Template.Input required label="کد تنوع" value={code} name="code" type="text" />

        <Template.SingleSelect
          withLabel
          required
          placeholder="انتخاب گارانتی"
          name="warranty_id"
          value={activeWarranty}
          onChange={value => setActiveWarranty(value)}
          options={warranties}
        />

        <Template.SingleSelect
          withLabel
          required
          placeholder="کانال فروش"
          onChange={value => setChannel(value)}
          name="channel"
          value={channel}
          options={[
            {
              value: "وب‌سایت",
              label: "وب‌سایت",
            },
          ]}
        />

        <Template.Input
          required
          label="بارکد تنوع"
          value={barcode}
          className="ltr"
          name="barcode"
          type="text"
        />

        <Template.Input
          required
          label="بازه زمانی ارسال (روز)"
          className="ltr"
          value={maxDeliveryDay}
          name="max_delivery_day"
          type="text"
        />

        <Template.Input
          required
          value={maxCartCount}
          label="حداکثر سفارش در سبد (عدد)"
          className="ltr"
          name="max_cart_count"
          type="text"
        />

        <Template.Input
          required
          label="موجودی نزد شما (عدد)"
          value={availableCount}
          className="ltr"
          name="available_count"
          type="text"
        />

        <Template.SingleSelect
          withLabel
          required
          placeholder="وضعیت"
          onChange={value => setActiveState(value)}
          name="state"
          value={activeState}
          options={[
            {
              value: "active",
              label: "فعال",
            },
            {
              value: "deactive",
              label: "غیرفعال",
            }
          ]}
        />

        <Template.Input
          required
          label="قیمت فروش (تومان)"
          className="ltr"
          name="price"
          value={priceValue}
          type="text"
        />

        <Template.Input
          required
          label="تخفیف (درصدی)"
          className="ltr"
          name="discount"
          value={discount}
          type="text"
        />

        <Template.SingleSelect
          withLabel
          required
          placeholder="ارسال توسط"
          onChange={value => setVia(value)}
          name="via"
          value={via}
          options={[
            {
              value: "وب‌سایت",
              label: "وب‌سایت",
            },
            {
              value: "فروشنده",
              label: "فروشنده",
            },
          ]}
        />


        <fieldset>
          <label className="text-gray-500">تاریخ تولید <i className="star ">*</i></label>
          <InputDatePicker onChange={(e) => setStartAt(e)} defaultValue={startAt} />
          <input
            type="hidden"
            name="start_at"
            defaultValue={startAt ? startAt.format("YYYY-MM-DD") : ""}
          />
        </fieldset>

        <fieldset>
          <label className="text-gray-500">تاریخ اعتبار <i className="star ">*</i></label>
          <InputDatePicker onChange={(e) => setExpireAt(e)} defaultValue={expireAt} />
          <input
            type="hidden"
            name="expire_at"
            defaultValue={expireAt ? expireAt.format("YYYY-MM-DD") : ""}
          />
        </fieldset>


        {updateId > 0 ? <Template.Button
          label="ویرایش"
          onClick={handleClickUpdate}
        /> : <Template.Button
          label="ذخیره"
          onClick={handleClick}
        />}

      </Template.Form>}

      <Template.Table columns={columns} data={productPrices} />

    </div>
  )
}

export default CreateProductPrice
